export default __webpack_public_path__ + "./images/recipes-2.png";